import React from 'react'
import { IconValueBlock, TooltipPopOver } from '@ztechapps/webui.util'
import { type InlineInputDisplayContent, type InlineInputProps, TextAreaInlineInput } from '@ztechapps/webui.input'
import isEmpty from 'lodash/isEmpty'

const displayContent: InlineInputDisplayContent = (e) => (
  <TooltipPopOver tooltipBody="Product Name / Description">
    <div className={'h4'}>
      <IconValueBlock icon="box" value={e} />
    </div>
  </TooltipPopOver>
)
export const NameInlineInput = (props: InlineInputProps) => {
  return (
    <TextAreaInlineInput
      name={'name'}
      displayContent={displayContent}
      validate={(e) => {
        if (isEmpty(e)) throw new Error('Required to have a value.')
      }}
      {...props}
    />
  )
}
NameInlineInput.displayContent = displayContent
